import React from "react";
import { useMessageSource } from "react-message-source";
import Typography from "../../../ui/widgets/typography";
import { ScdAccordion } from "../../../ui/widgets/accordion";
import { ScdAccordionSummary } from "../../../ui/widgets/accordion/summary";
import { ScdAccordionDetails } from "../../../ui/widgets/accordion/details";

export default function Notes({
  showSwisscardDetails,
}: {
  showSwisscardDetails: boolean;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();
  const swissCardHints = showSwisscardDetails
    ? "InsurancePlus.include.hints.swisscard.text"
    : "InsurancePlusOptional.include.hints.text";

  return (
    <ScdAccordion>
      <ScdAccordionSummary>
        <Typography variant="body2">
          {getMessage("InsurancePlusOptional.include.hints.title")}
        </Typography>
      </ScdAccordionSummary>
      <ScdAccordionDetails>
        <div className="scd-column-text">{getMessage(swissCardHints)}</div>
      </ScdAccordionDetails>
    </ScdAccordion>
  );
}
